import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import '../reportStyles.scss';
import { errorNormalizer } from '../../../shared/Helpers/functions';
import { CustomButton } from '../../../shared/uiComponents';
import { ReportFilters, downloadFile } from '../helpers';
import { REPORT_GENERATION_MESSAGE } from '../../../shared/Helpers/constants';
import UtilizationReportFilters from './UtilizationReportFilters';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getUtilizationReport } from '../../../redux/State/clientSlice/insuranceAuthorizationSlice';

const UtilizationReport = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const filterData = useSelector((state) => state.billing.billingFilters);
	const loading = useSelector((state) => state.authorization.loading);

	const downloadHandler = useCallback(() => {
		const { startDate, endDate, clientIds, providerIds, roleSections, authorizationSessionTypeIds } = filterData;

		toast(REPORT_GENERATION_MESSAGE);

		dispatch(
			getUtilizationReport({
				clientIds,
				startDate,
				endDate,
				providerIds,
				roleSections,
				authorizationSessionTypeId: authorizationSessionTypeIds,
			}),
		)
			.then(unwrapResult)
			.then((response) => downloadFile(response))
			.catch(errorNormalizer);
	}, [dispatch, filterData]);

	return (
		<>
			<UtilizationReportFilters />
			<ReportFilters showUsers={false} isMultipleSelect showOnlyNew={false} />
			<div style={{ width: 'max-content' }}>
				<CustomButton title="Download" onClick={downloadHandler} loading={loading} disabled={filterData.timeError} />
			</div>
		</>
	);
};

export default UtilizationReport;
